let tourInstance = null

export default {
  install(Vue) {
    Vue.prototype.$tourManager = {
      register(instance) {
        tourInstance = instance
      },
      start(tourModule) {
        if (tourInstance) {
          tourInstance.startTour(tourModule)
        } else {
          console.warn('TourManager 未初始化')
        }
      },
      stop() {
        tourInstance?.stopTour()
      },
      isRunning() {
        return tourInstance?.isRunning() || false
      }
    }
  }
}
